import * as React from "react"
import "./spacer.scss"

export const Spacer: React.FC = () => {
  return <div className="tiptap-spacer" />
}
